// extracted by mini-css-extract-plugin
export var autoWidth = "Button-module--auto-width--76965";
export var button = "Button-module--button--c4333";
export var buttonGreenish = "Button-module--buttonGreenish--b1352";
export var buttonMedium = "Button-module--button-medium--b94cf";
export var buttonSmall = "Button-module--button-small--4bdad";
export var inverse = "Button-module--inverse--2c5c3";
export var outlined = "Button-module--outlined--8d79c";
export var secondary = "Button-module--secondary--1edb8";